import { DownloadItem, IpcMainInvokeEvent } from "electron";
import getMainBrowserWindow from "../DependencyInjection/mainBrowserWindow";
import getEventDispatcher from "../DependencyInjection/eventDispatcher";
import {DownloadProgress} from "../../../types/downloadManager";

const mainWindow = getMainBrowserWindow();
const eventDispatcher = getEventDispatcher();

export interface ProgressStrategy {
    isValid(progress: DownloadProgress, item: DownloadItem): boolean;

    onProgress(progress: DownloadProgress, item: DownloadItem): void;
}

export class UpdateProgressStrategy implements ProgressStrategy {
    public isValid(progress: DownloadProgress, item: DownloadItem): boolean {
        return true;
    }

    public async onProgress(progress: DownloadProgress, item: DownloadItem): Promise<void> {
        mainWindow.setProgressBar(progress.percentage);
        await eventDispatcher.dispatch('DownloadProgress', progress);
    }
}

export class SlowProgressStrategy implements ProgressStrategy {
    public isValid(progress: DownloadProgress, item: DownloadItem): boolean {
        return 0 === progress.speedBytes
            && 100 !== progress.progress
    }

    public onProgress(progress: DownloadProgress, item: DownloadItem): void {
        console.warn('Slowdown detected while processing: ', item.getFilename(), progress);
    }
}

export class StarProgressStrategy implements ProgressStrategy {
    public isValid(progress: DownloadProgress, item: DownloadItem): boolean {
        return 0 === progress.progress;
    }

    public onProgress(progress: DownloadProgress, item: DownloadItem): void {
        eventDispatcher.addHandler('PauseDownloadManager',
            (event: IpcMainInvokeEvent, content: null) => {
                item.pause();
            }
        );

        eventDispatcher.addHandler('ResumeDownloadManager',
            (event: IpcMainInvokeEvent, content: null) => {
                item.resume();
            }
        );

        eventDispatcher.addHandler('CancelDownloadManager',
            (event: IpcMainInvokeEvent, content: null) => {
                item.cancel();
            }
        );
    }
}

export class FinishProgressStrategy implements ProgressStrategy {
    public isValid(progress: DownloadProgress, item: DownloadItem): boolean {
        return 100 === progress.progress;
    }

    public onProgress(progress: DownloadProgress, item: DownloadItem): void {
        try {
            eventDispatcher.removeHandler('PauseDownloadManager');
            eventDispatcher.removeHandler('ResumeDownloadManager');
            eventDispatcher.removeHandler('CancelDownloadManager');
        } catch (error) {
            console.warn('Error after progress = 100 and no remaining bytes', error);
        }
    }
}